<template>
  <div>
    <v-toolbar-title class="d-flex mt-2 mb-6">
      <span style="font-weight: 700 !important; color: #26384B; font-size: 21px">{{ $t('clients.accessGroups') }}</span>
    </v-toolbar-title>
    <form>
      <AccessGroupForm
        ref="mainForm"
        :accessGroups="updatedData"
        :isEditable="formEditable"
        @dirtyChanged="isFormDirty = $event"
        @validChanged="isFormValid = $event"
        @sendData="updateData"
      />

      <v-row
        v-if="formEditable"
        align="center"
        justify="end"
        class="mr-1"
      >
        <v-btn
          :disabled="!isFormValid || !isFormDirty"
          type="submit"
          color="secondary"
          @click.prevent="onClickUpdate"
        >
          {{ $t('forms.btn.save') }}
        </v-btn>
      </v-row>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FormPageMixin from '@/mixins/FormPageMixin';
import AccessGroupForm from '@/components/forms/AccessGroupForm';

export default {
    components: {
        AccessGroupForm,
    },
    mixins: [
        FormPageMixin,
    ],
    data() {
        return {
            accessGroups: [],
        };
    },
    computed: {
        ...mapGetters([
            'client',
        ]),
        defaultData() {
            return this.accessGroups;
        },
    },
    async created() {
        await this.getClientAccessGroups();
    },
    methods: {
        async getClientAccessGroups() {
            const { data } = await this.$rq.getAccessGroups({ clientId: this.client.id, pagination: false });
            this.accessGroups = data.accessGroups.map(({ id }) => id);
            this.initFormData();
        },
        async updateData(data) {
            await this.$rq.updateClientAccessGroup(this.client.id, { accessGroups: data });
            await this.getClientAccessGroups();
            this.cancelModifications();
        },
    },
};
</script>
